import { haveSameNumericValues } from "utils";

const { useState, useEffect } = require("react");
const { default: SidebarCheckbox } = require("./SidebarCheckbox");

const MEMBER_TYPE_OPTIONS = [
  { value: "4", label: "All Members" },
  { value: "1", label: "Active Members" },
  { value: "2", label: "Inactive Members" },
  { value: "3", label: "Pending Members" },
];
export const allMembersValue = MEMBER_TYPE_OPTIONS[0].value;
const allValueArray = [allMembersValue];
const FilterMemberType = ({ allFiltersRef, resetFilters, preSetter }) => {
  const [multiSelection, setMultiSelection] = useState(
    preSetter || allValueArray
  );
  const selectedAll = multiSelection.includes(allMembersValue);
  const onSelect = (e, item) => {
    if (item.value === allMembersValue) {
      if (!selectedAll) {
        setMultiSelection(allValueArray);
      }
      return;
    }
    const checked = e.target.checked;
    setMultiSelection((prev) => {
      // If "All" was selected previously and user checks something else,
      // start fresh with only the new value
      if (checked && selectedAll) {
        return [item.value];
      }
      // Add the value when checked
      if (checked) {
        return [...prev, item.value];
      }
      // Remove the value when unchecked
      const next = prev.filter((v) => v !== item.value);
      // If nothing left, default back to allValueArray
      return next.length ? next : allValueArray;
    });
  };
  useEffect(() => {
    const typeArray = allFiltersRef.current?.type;
    if (typeArray) {
      allFiltersRef.current.type = multiSelection;
    }
  }, [multiSelection]);
  useEffect(() => {
    if (resetFilters) {
      setMultiSelection(allValueArray);
    }
  }, [resetFilters]);
  return (
    <SidebarCheckbox
      data={MEMBER_TYPE_OPTIONS}
      renderName={(item) => item.label}
      checked={(item) =>
        selectedAll
          ? allMembersValue === item.value
          : multiSelection.includes(item.value)
      }
      handleChange={onSelect}
    />
  );
};
export default FilterMemberType;
